import ClientFormData from '../../../../../models/helperTypes/ClientFormData';
import CustomerItem from '../../../../../models/helperTypes/CustomerItem';

export default function makeInitialFormData(
  customer: CustomerItem,
  profile: string,
): ClientFormData {
  const useEmptyValues = !customer.driverAndCustomerAreDifferent;
  return {
    // Either Legal Person or Natural Person
    type: customer.type,
    sendEmailCreatorUser: customer.sendEmailCreatorUser,

    // natural person customer
    firstName: customer.firstName,
    lastName: customer.lastName,
    gender: customer.gender,
    birthday: customer.birthday,

    // legal person customer
    entityName: customer.entityName,

    // general customer data
    email: customer.email,
    phoneNumber: customer.phoneNumber,

    // driver different
    driverAndCustomerAreDifferent: customer.driverAndCustomerAreDifferent,
    driverFirstName: useEmptyValues ? '' : customer.driverFirstName,
    driverLastName: useEmptyValues ? '' : customer.driverLastName,
    driverGender: useEmptyValues ? '' : customer.driverGender,
    driverBirthday: useEmptyValues ? '' : customer.driverBirthday,
    driverIdNumber: useEmptyValues ? '' : customer.driverIdNumber,
    driverIdType: useEmptyValues ? 'N' : customer.driverIdType,

    profile,
  };
}
